import { env } from 'process'
import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

import { cookies } from '@jotta/utils/cookie'

export type PendingFederation = {
  token: string
  nonce: string
  hashedNonce: string
}

type FederationState = {
  pendingFederation?: PendingFederation
  setPendingFederation: (federationToken?: PendingFederation) => void
}

export const useFederationStore = create<FederationState>()(
  devtools(
    (set, get) => ({
      pendingFederation: undefined,
      setPendingFederation: pendingFederation =>
        set(state => ({
          ...state,
          pendingFederation,
        })),
    }),
    { name: 'AuthStore', enabled: !env.isProduction },
  ),
)

export const setPendingFederation = (pendingFederation: PendingFederation) => {
  return useFederationStore.getState().setPendingFederation(pendingFederation)
}

const federationTokenNonceCookieName = (hashedFederationTokenNonce: string) => {
  return `login_state_${hashedFederationTokenNonce}`
}
const federationTokenNonceCookieOptions = {
  maxAge: 30 * 60,
  path: '/',
}
export const persistFederationTokenNonce = (
  hashedFederationTokenNonce: string,
  federationTokenNonce: string,
) => {
  // The federation token nonce must survive redirects to external federation provider (unlike the federation token which can be kept in memory)
  // so we store it in a cookie in addition to updating the in-memory state:
  cookies.set(
    federationTokenNonceCookieName(hashedFederationTokenNonce),
    federationTokenNonce,
    federationTokenNonceCookieOptions,
  )
}
export const loadFederationTokenNonce = (
  hashedFederationTokenNonce: string,
) => {
  return cookies.get(federationTokenNonceCookieName(hashedFederationTokenNonce))
}
export const clearFederationTokenNonce = (
  pendingFederation: PendingFederation,
) => {
  cookies.remove(
    federationTokenNonceCookieName(pendingFederation.hashedNonce),
    federationTokenNonceCookieOptions,
  )
}
